import { AuthService } from "@/services/auth";
import { DataService } from "@/services/data";
import { redirect, RouteObject } from "react-router-dom";

type SfRedirectResponse = {
    path: string;
    object_type: string;
    pk: number;
};

/**
 * Technical URL: paste any known Salesforce id and land on the matching CRM detail page.
 * Example: /sf/500IV00001AbCdEfGh → /cases/123
 */
const SFRedirectRoute: RouteObject = {
    path: "sf/:sfId",
    loader: async ({ params }) => {
        const sfId = (params.sfId || "").trim();
        if (!sfId) {
            return redirect("/search");
        }

        // The redirect endpoint is anonymous, so calling it while logged out would race
        // the SSO navigation and drop the return URL. Hand over to AppLayout instead:
        // it redirects with `state.from`, and the loader replays after login.
        if (!AuthService.get_tokens() || AuthService.has_refresh_expires()) {
            return null;
        }

        try {
            const data = (await DataService.client
                .url(`/salesforce/redirect/${encodeURIComponent(sfId)}/`)
                .query({ format: "json" })
                .get()
                .json()) as SfRedirectResponse;

            if (data?.path) {
                return redirect(data.path);
            }
        } catch {
            // fall through
        }

        // nofollow avoids an infinite bounce with SearchPage's sf_id guard
        return redirect(`/search?q=${encodeURIComponent(sfId)}&nofollow=1`);
    },
    element: null
};

export default SFRedirectRoute;
